function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3748",
  "data-name": "Group 3748",
  transform: "translate(-1195 -520)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Elipse_24",
  "data-name": "Elipse 24",
  transform: "translate(1195 520)",
  fill: "none",
  stroke: "#395c81",
  strokeLinecap: "round",
  strokeWidth: 15
}, /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 98,
  r: 98,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 98,
  r: 90.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_48",
  "data-name": "Caminho 48",
  d: "M0,29.986l30.588,33.2L86.7,0",
  transform: "matrix(0.996, -0.087, 0.087, 0.996, 1251.349, 597.16)",
  fill: "none",
  stroke: "#395c81",
  strokeLinecap: "round",
  strokeWidth: 15
}));

var SvgBigCheck = function SvgBigCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 196,
    viewBox: "0 0 196 196",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBigCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bigCheck.c2954aa5.svg";
export { ForwardRef as ReactComponent };